















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import HeaderComponents from "./../../../../Assets/Card/Header/Header.vue";
import BodyComponents from "./../../../../Assets/Card/Body/Body.vue";
import FooterComponents from "./../../../../Assets/Card/Footer/Footer.vue";
import { http } from "@/shared/https";

/**
 * Component's properties and events
 */
@Component({
  components: {
    HeaderComponents,
    BodyComponents,
    FooterComponents,
  },
})
export default class UserComponent extends Vue {
  data() {
    return this.$store.state.userIndex;
  }

  //#. The beforeCreate() hook observes data and initialization events in your component.
  beforeCreate() {}

  //#. The created() hook is invoked when Vue has set up events and data observation.
  created() {}

  //#. The beforeMount() method is invoked after our template has been compiled and our virtual DOM updated by Vue.
  beforeMount() {}

  //#. The mounted() method gives you access to templates and enables interaction with the DOM.
  mounted() {}

  // #. The beforeUpdate hook runs after data changes on your component and the update cycle begins, right before the DOM is patched and re- rendered.
  beforeUpdate() {}

  // #. The updated hook runs after data changes on your component and the DOM re-renders
  updated() {}

  // #. beforeDestroy is fired right before teardown. Your component will still be fully present and functional.
  beforeDestroy() {}

  // #. By the time you reach the destroyed hook, there�s pretty much nothing left on your component
  destroyed() {}

  resetPassword(userId) {
    this.$store.state.userIndex.userNotify.value = null;
    this.$store.state.userIndex.userNotify.enabled = false;
    this.$store.state.userIndex.userNotify.text = '';

    return http.get("/api/User/ResetPassword/" + userId).then((record) => {
      if (record.data.Result == "OK") {
        this.$store.state.dashboard.color = "success";
        this.$store.state.dashboard.text = record.data.Message;
        this.$store.state.dashboard.snackbar = true;
      }
    });
  }

  nfClose() {
    this.$store.state.userIndex.userNotify.enabled = false;
    this.$store.state.userIndex.userNotify.text = '';
  }
}
